import { createMachine } from "xstate";
import { Segment } from "src/types";

type SELECT_NEW_EVENT = { type: "SELECT_NEW"; payload: Segment["segmentId"][] };
type SELECT_ADD_EVENT = { type: "SELECT_ADD"; payload: Segment["segmentId"][] };
type SELECT_ADD_XOR_EVENT = { type: "SELECT_ADD_XOR"; payload: Segment["segmentId"][] };

export const segmentsSelectionMachine = createMachine({
  id: "segment-selection",
  initial: "select",
  states: {
    select: {
      on: {
        SELECT_NEW: {
          target: "select",
          actions: "selectNew",
        },
        SELECT_ADD_XOR: {
          target: "select",
          actions: "selectAddXor",
        },
        LASSO_SELECT: {
          target: "select_with_lasso",
        },
        DRAW_SEGMENT: {
          target: "draw",
        },
        CANCEL: { actions: [] },
      },
    },
    select_with_lasso: {
      // entry: ["resetDrawing"],
      on: {
        SELECT_NEW: {
          target: "select",
          actions: "selectNew",
        },
        SELECT_ADD: {
          target: "select",
          actions: "selectAdd",
        },
        DRAW_SEGMENT: {
          target: "draw",
        },
        CANCEL: { target: "select", actions: [] },
      },
    },
    draw: {
      on: {
        LASSO_SELECT: {
          target: "select_with_lasso",
        },
        CREATE_SEGMENT: {
          target: "select",
          actions: ["createNewSegment"],
        },
        CANCEL: { target: "select", actions: [] },
      },
    },
  },
});
